const FromArr = [
  {
    title: "业务负责人",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "业务负责人",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 0,
    marginTop: 35,
    X: false,
  },
  {
    title: "业务负责人电话",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "业务负责人电话",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 30,
    marginTop: 35,
    X: false,
  },
  {
    title: "业务负责人邮箱",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "业务负责人邮箱",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 30,
    marginTop: 35,
    X: false,
  },
  {
    title: "数据上报联系人",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "数据上报联系人",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 0,
    marginTop: 35,
    X: false,
  },
  {
    title: "数据上报联系人电话",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "数据上报联系人电话",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 30,
    marginTop: 35,
    X: false,
  },
  {
    title: "数据上报联系人邮箱",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "数据上报联系人邮箱",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 30,
    marginTop: 35,
    X: false,
  },
  {
    title: "收货联系人",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "收货联系人",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 0,
    marginTop: 35,
    X: false,
  },
  {
    title: "收货联系人电话",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "收货联系人电话",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 30,
    marginTop: 35,
    X: false,
  },
  {
    title: "收货地址",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "收货地址",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 30,
    marginTop: 35,
    X: false,
  },
  {
    title: "发票联系人",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "发票联系人",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 0,
    marginTop: 35,
    X: false,
  },
  {
    title: "发票联系人电话",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "发票联系人电话",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 30,
    marginTop: 35,
    X: false,
  },
  {
    title: "发票收件地址",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "发票收件地址",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 30,
    marginTop: 35,
    X: false,
  },
  {
    title: "文件联系人",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "文件联系人",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 0,
    marginTop: 35,
    X: false,
  },
  {
    title: "文件联系人电话",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "文件联系人电话",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 30,
    marginTop: 35,
    X: false,
  },
  {
    title: "文件联系人邮箱",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "文件联系人邮箱",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 30,
    marginTop: 35,
    X: false,
  },
  {
    title: "文件收件地址",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "文件收件地址",
    width: 890,
    height: 32,
    disabled: false,
    marginLeft: 0,
    marginTop: 35,
    X: false,
  },
];
export default FromArr;
